import { Directive, Input, OnInit, Optional, TemplateRef, ViewContainerRef } from "@angular/core";
import { isAdmin } from "@app/_helpers/permission";
import { UserSettingsQuery } from "@timeghost/web-api";

@Directive({
	selector: "[canAccessBeta]",
})
export class CanAccessBetaDirective implements OnInit {
	@Input()
	canAccessBeta: boolean = true;

	constructor(
		private viewContainer: ViewContainerRef,
		@Optional() private templateRef: TemplateRef<any>,
		private userSettingsQuery: UserSettingsQuery
	) {}

	ngOnInit() {
		this.updateView();
	}

	private updateView() {
		const userSettings = this.userSettingsQuery.getValue();
		const canAccess = this.canUserAccessBeta(userSettings);

		if (canAccess && this.templateRef) {
			this.viewContainer.createEmbeddedView(this.templateRef);
		} else {
			this.viewContainer.clear();
		}
	}

	private canUserAccessBeta(userSettings: any): boolean {
		if (!userSettings?.workspace) {
			return false;
		}

		// Admins always have access to beta features
		if (isAdmin(userSettings)) {
			return true;
		}

		// For non-admins, check the workspace setting
		const nonAdminsCanAccessBeta = userSettings.workspace.settings?.nonAdminsCanAccessBeta;

		// If the setting is explicitly set to false, non-admins cannot access
		if (nonAdminsCanAccessBeta === false) {
			return false;
		}

		// If the setting is true, undefined, or null, non-admins can access
		return true;
	}
}
